var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { DeleteIcon, EditIcon, UpIcon, DownIcon, AddIcon, } from '../../utils/Icons';
import { TYPES } from '../../utils/FormikTextField';
import { FormikGenerator } from '../../utils/FormikGenerator';
import { Modal } from '../../utils/Modal';
import { IconButton } from '../../utils/IconButton';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import * as ServiceCatalogue from '../../services/catalogue';
import * as ServiceUtils from '../../services/utils';
import { Stack, Table, TableCell, TableRow, TableHead, TableBody, TableContainer, Paper, } from '@mui/material';
import { CatalogueSchema, TypeSchema } from '../../utils/ValidationSchema';
import { formatNumber } from '../../services/utils/utils';
import { getOriginalUser } from '../../services/utilisateur';
import * as ServiceAdministration from '../../services/administration';
import { Switch } from '../../utils/Switch';
import { Button } from '../../utils/Button';
import { getBackgroundColor, getColors } from '../../utils/Classes';
var KEY_ROW = {
    TYPE: 'type',
    FAMILLE: 'famille',
};
export var Catalogue = function () {
    var palette = getColors();
    var originalUser = getOriginalUser();
    var _a = useState({}), openRow = _a[0], setOpenRow = _a[1];
    var _b = useState([]), catalogues = _b[0], setCatalogues = _b[1];
    var _c = useState([]), famillesCatalogue = _c[0], setFamillesCatalogue = _c[1];
    var _d = useState([]), types = _d[0], setTypes = _d[1];
    var _e = useState(false), openAll = _e[0], setOpenAll = _e[1];
    var _f = useState(null), produitSelected = _f[0], setProduitSelected = _f[1];
    var _g = useState(null), familleSelected = _g[0], setFamilleSelected = _g[1];
    var _h = useState(null), typeSelected = _h[0], setTypeSelected = _h[1];
    var _j = useState([]), optionsTypes = _j[0], setOptionsTypes = _j[1];
    var getData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var datas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        ServiceCatalogue.getCatalogueListe(),
                        ServiceUtils.getListe('CatalogueFamille'),
                        ServiceUtils.getTypes('Catalogue'),
                    ])];
                case 1:
                    datas = _a.sent();
                    setTypes(datas[0]);
                    setFamillesCatalogue(datas[1]);
                    setOptionsTypes(datas[2]);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        getData();
    }, [getData]);
    var handleDeleteProduit = function (_a) {
        var IdCatalogue = _a.IdCatalogue;
        return __awaiter(void 0, void 0, void 0, function () {
            var confirmation;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ConfirmDialog({
                            title: 'Suppression',
                            content: 'Êtes-vous sûr de vouloir supprimer ce produit / service ?',
                            color: 'error',
                        })];
                    case 1:
                        confirmation = _b.sent();
                        if (!confirmation.isOk) return [3 /*break*/, 3];
                        return [4 /*yield*/, ServiceCatalogue.deleteCatalogue(IdCatalogue)];
                    case 2:
                        _b.sent();
                        getData();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var handleDeleteFamille = function (_a) {
        var IdCatalogueFamille = _a.IdCatalogueFamille;
        return __awaiter(void 0, void 0, void 0, function () {
            var confirmation;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ConfirmDialog({
                            title: 'Suppression',
                            content: 'Êtes-vous sûr de vouloir supprimer cette gamme ?',
                            color: 'error',
                        })];
                    case 1:
                        confirmation = _b.sent();
                        if (!confirmation.isOk) return [3 /*break*/, 3];
                        return [4 /*yield*/, ServiceAdministration.deleteAdministration('CatalogueFamille', IdCatalogueFamille)];
                    case 2:
                        _b.sent();
                        getData();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var handleDeleteType = function (_a) {
        var IdType = _a.IdType;
        return __awaiter(void 0, void 0, void 0, function () {
            var confirmation;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ConfirmDialog({
                            title: 'Suppression',
                            content: 'Êtes-vous sûr de vouloir supprimer cette famille ?',
                            color: 'error',
                        })];
                    case 1:
                        confirmation = _b.sent();
                        if (!confirmation.isOk) return [3 /*break*/, 3];
                        return [4 /*yield*/, ServiceAdministration.deleteAdministration('Type', IdType)];
                    case 2:
                        _b.sent();
                        getData();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var getKeyRow = function (level, id) {
        return "".concat(level, "-").concat(id);
    };
    var handleOpenRow = function (level, id) {
        var _a;
        var key = getKeyRow(level, id);
        setOpenRow(__assign(__assign({}, openRow), (_a = {}, _a[key] = !openRow[key], _a)));
    };
    var isOpenRow = function (level, id) {
        var key = getKeyRow(level, id);
        return openRow[key];
    };
    var RowFamille = function (_a) {
        var famille = _a.famille;
        var IdCatalogueFamille = famille.IdCatalogueFamille, Libelle = famille.Libelle, produits = famille.produits;
        return (_jsxs(_Fragment, { children: [_jsxs(TableRow, { children: [_jsx(TableCell, {}), _jsxs(TableCell, __assign({ className: "pointer", onClick: function () { return handleOpenRow(KEY_ROW.FAMILLE, IdCatalogueFamille); } }, { children: [_jsx(IconButton, __assign({ tooltip: "Afficher / Masquer", size: "small", onClick: function () { return handleOpenRow(KEY_ROW.FAMILLE, IdCatalogueFamille); } }, { children: isOpenRow(KEY_ROW.FAMILLE, IdCatalogueFamille) ? (_jsx(UpIcon, {})) : (_jsx(DownIcon, {})) })), Libelle] })), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {}), originalUser.Licence.UseTva ? _jsx(TableCell, {}) : _jsx(_Fragment, {}), _jsx(TableCell, __assign({ align: "right", sx: { width: 0 } }, { children: _jsxs(Stack, __assign({ direction: "row", justifyContent: "end", spacing: 1 }, { children: [_jsx(IconButton, __assign({ color: "primary", tooltip: "Modifier", onClick: function () { return setFamilleSelected(famille); } }, { children: _jsx(EditIcon, {}) })), _jsx(IconButton, __assign({ color: "error", tooltip: "Supprimer", onClick: function () { return handleDeleteFamille(famille); }, disabled: famille.produits && famille.produits.length > 0 }, { children: _jsx(DeleteIcon, {}) }))] })) }))] }), isOpenRow(KEY_ROW.FAMILLE, IdCatalogueFamille) ? (produits.map(function (produit) { return (_jsxs(TableRow, { children: [_jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, { children: produit.Libelle }), _jsx(TableCell, __assign({ align: "right" }, { children: produit.WithQuantite
                                ? "".concat(formatNumber(produit.Quantite), " ").concat(produit.Unite ? produit.Unite : '')
                                : '' })), _jsx(TableCell, __assign({ align: "right" }, { children: formatNumber(produit.Tarif, '€') })), _jsx(TableCell, __assign({ align: "right" }, { children: formatNumber(produit.Cout, '€') })), originalUser.Licence.UseTva ? (_jsx(TableCell, __assign({ align: "right" }, { children: produit.Tva }))) : (_jsx(_Fragment, {})), _jsx(TableCell, __assign({ align: "right", sx: { width: 0 } }, { children: _jsxs(Stack, __assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(IconButton, __assign({ color: "primary", tooltip: "Modifier", onClick: function () { return setProduitSelected(produit); } }, { children: _jsx(EditIcon, {}) })), _jsx(IconButton, __assign({ color: "error", tooltip: "Supprimer", onClick: function () { return handleDeleteProduit(produit); } }, { children: _jsx(DeleteIcon, {}) }))] })) }))] }, produit.IdCatalogue)); })) : (_jsx(_Fragment, {}))] }));
    };
    var RowType = function (_a) {
        var type = _a.type;
        var IdType = type.IdType, Libelle = type.Libelle, familles = type.familles;
        return (_jsxs(_Fragment, { children: [_jsxs(TableRow, { children: [_jsxs(TableCell, __assign({ className: "pointer", onClick: function () { return handleOpenRow(KEY_ROW.TYPE, IdType); } }, { children: [_jsx(IconButton, __assign({ tooltip: "Afficher / Masquer", size: "small", onClick: function () { return handleOpenRow(KEY_ROW.TYPE, IdType); } }, { children: isOpenRow(KEY_ROW.TYPE, IdType) ? _jsx(UpIcon, {}) : _jsx(DownIcon, {}) })), Libelle] })), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {}), originalUser.Licence.UseTva ? _jsx(TableCell, {}) : _jsx(_Fragment, {}), _jsx(TableCell, __assign({ align: "right", sx: { width: 0 } }, { children: _jsxs(Stack, __assign({ direction: "row", justifyContent: "end", spacing: 1 }, { children: [_jsx(IconButton, __assign({ color: "primary", tooltip: "Modifier", onClick: function () { return setTypeSelected(type); } }, { children: _jsx(EditIcon, {}) })), _jsx(IconButton, __assign({ color: "error", tooltip: "Supprimer", onClick: function () { return handleDeleteType(type); }, disabled: familles && familles.length > 0 }, { children: _jsx(DeleteIcon, {}) }))] })) }))] }), isOpenRow(KEY_ROW.TYPE, IdType) && familles ? (familles.map(function (famille) { return (_jsx(RowFamille, { famille: famille }, famille.IdCatalogueFamille)); })) : (_jsx(_Fragment, {}))] }));
    };
    var renderEditionProduit = function () {
        if (!produitSelected) {
            return;
        }
        return (_jsx(Modal, __assign({ handleCloseModal: function () { return setProduitSelected(null); }, forceOpen: true, title: "Produit / Service" }, { children: _jsx(FormikGenerator, { validationSchema: CatalogueSchema, submitLabel: produitSelected.IdCatalogue ? 'Enregistrer' : 'Ajouter', datas: __assign(__assign({ Actif: true, WithQuantite: true }, produitSelected), { TvaParDefaut: produitSelected.Tva === null || produitSelected.Tva === undefined }), onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (values.TvaParDefaut) {
                                    values.Tva = null;
                                }
                                return [4 /*yield*/, ServiceCatalogue.postCatalogue(__assign(__assign({}, produitSelected), values))];
                            case 1:
                                _a.sent();
                                setProduitSelected(null);
                                getData();
                                return [2 /*return*/];
                        }
                    });
                }); }, fields: [
                    [
                        /*{
                          xs: 4,
                          name: 'Actif',
                          label: 'Actif',
                          type: TYPES.BOOLEAN,
                        },*/
                        {
                            xs: 4,
                            name: 'WithQuantite',
                            label: 'Avec quantité',
                            type: TYPES.BOOLEAN,
                        },
                    ],
                    [
                        {
                            name: 'CatalogueFamilleId',
                            label: 'Gamme',
                            type: TYPES.SELECT,
                            options: famillesCatalogue ? famillesCatalogue : [],
                            xs: 12,
                        },
                        {
                            name: 'Libelle',
                            label: 'Intitulé du produit / service',
                            type: TYPES.TEXT,
                            uppercaseFirstChar: true,
                            xs: 12,
                        },
                        {
                            xs: 6,
                            name: 'Quantite',
                            label: 'Quantité',
                            type: TYPES.TEXT,
                            onlyDigits: true,
                            smallerThanZero: true,
                            show: function (value) { return value.WithQuantite; },
                        },
                        {
                            xs: 6,
                            name: 'Unite',
                            label: 'Unité',
                            type: TYPES.TEXT,
                            show: function (value) { return value.WithQuantite; },
                        },
                        {
                            xs: 6,
                            name: 'Tarif',
                            label: 'Tarif',
                            type: TYPES.TEXT,
                            onlyDigits: true,
                            smallerThanZero: true,
                        },
                        {
                            xs: 6,
                            name: 'Cout',
                            label: 'Cout',
                            type: TYPES.TEXT,
                            onlyDigits: true,
                            smallerThanZero: true,
                        },
                        {
                            xs: 6,
                            name: 'TvaParDefaut',
                            label: 'Tva par défaut',
                            type: TYPES.BOOLEAN,
                            show: function () { return originalUser.Licence.UseTva; },
                        },
                        {
                            xs: 6,
                            name: 'Tva',
                            label: 'Tva',
                            type: TYPES.TEXT,
                            onlyDigits: true,
                            show: function (values) {
                                return originalUser.Licence.UseTva && !values.TvaParDefaut;
                            },
                        },
                    ],
                ] }) })));
    };
    var renderEditionFamille = function () {
        if (!familleSelected) {
            return;
        }
        return (_jsx(Modal, __assign({ handleCloseModal: function () { return setFamilleSelected(null); }, forceOpen: true, title: "Gamme de produit / service" }, { children: _jsx(FormikGenerator, { submitLabel: familleSelected.IdCatalogueFamille ? 'Enregistrer' : 'Ajouter', datas: __assign(__assign({}, familleSelected), { Actif: familleSelected.Actif === undefined
                        ? true
                        : familleSelected.Actif }), validationSchema: TypeSchema, onSubmit: function (_a) {
                    var Actif = _a.Actif, Libelle = _a.Libelle, CatalogueTypeId = _a.CatalogueTypeId;
                    return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, ServiceAdministration.postAdministration('CatalogueFamille', __assign(__assign({}, familleSelected), { CatalogueTypeId: CatalogueTypeId, Actif: Actif, Libelle: Libelle }))];
                                case 1:
                                    _b.sent();
                                    setFamilleSelected(null);
                                    getData();
                                    return [2 /*return*/];
                            }
                        });
                    });
                }, fields: [
                    [
                        /*{
                          name: 'Actif',
                          label: 'Actif',
                          type: TYPES.BOOLEAN,
                        },*/
                        {
                            name: 'CatalogueTypeId',
                            label: 'Famille',
                            type: TYPES.SELECT,
                            options: optionsTypes,
                        },
                        {
                            name: 'Libelle',
                            label: 'Intitulé de la gamme',
                            type: TYPES.TEXT,
                            uppercaseFirstChar: true,
                        },
                    ],
                ] }) })));
    };
    var renderEditionType = function () {
        if (!typeSelected) {
            return;
        }
        return (_jsx(Modal, __assign({ handleCloseModal: function () { return setTypeSelected(null); }, forceOpen: true, title: "Famille de gamme de produit / service" }, { children: _jsx(FormikGenerator, { submitLabel: typeSelected.IdType ? 'Enregistrer' : 'Ajouter', datas: __assign(__assign({}, typeSelected), { Actif: typeSelected.Actif === undefined ? true : typeSelected.Actif }), validationSchema: TypeSchema, onSubmit: function (_a) {
                    var Actif = _a.Actif, Libelle = _a.Libelle;
                    return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, ServiceAdministration.postAdministration('Type', __assign(__assign({}, typeSelected), { Model: 'Catalogue', Actif: Actif, Libelle: Libelle }))];
                                case 1:
                                    _b.sent();
                                    setTypeSelected(null);
                                    getData();
                                    return [2 /*return*/];
                            }
                        });
                    });
                }, fields: [
                    [
                        {
                            name: 'Libelle',
                            label: 'Intitulé de la famille',
                            type: TYPES.TEXT,
                            uppercaseFirstChar: true,
                        },
                    ],
                ] }) })));
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Stack, __assign({ direction: "row", spacing: 2, justifyContent: "flex-end" }, { children: [_jsx(Button, __assign({ size: "small", color: "primary", onClick: function () { return setTypeSelected({}); }, endIcon: _jsx(AddIcon, {}) }, { children: "Ajouter une famille" })), _jsx(Button, __assign({ size: "small", color: "primary", onClick: function () { return setFamilleSelected({}); }, endIcon: _jsx(AddIcon, {}) }, { children: "Ajouter une gamme" })), _jsx(Button, __assign({ size: "small", color: "primary", onClick: function () { return setProduitSelected({}); }, endIcon: _jsx(AddIcon, {}) }, { children: "Ajouter un produit / service" })), _jsx(Switch, { label: "Tout ouvrir", checked: openAll, onChange: function (e) {
                            var checked = e.target.checked;
                            setOpenAll(checked);
                            if (checked) {
                                var newOpenRow = {};
                                for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
                                    var type = types_1[_i];
                                    newOpenRow[getKeyRow(KEY_ROW.TYPE, type.IdType)] = true;
                                    for (var _a = 0, _b = type.familles; _a < _b.length; _a++) {
                                        var famille = _b[_a];
                                        newOpenRow[getKeyRow(KEY_ROW.FAMILLE, famille.IdCatalogueFamille)] = true;
                                    }
                                }
                                setOpenRow(newOpenRow);
                            }
                            else {
                                setOpenRow({});
                            }
                        } })] })), _jsx(TableContainer, __assign({ className: "mt-small", component: Paper }, { children: _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ sx: __assign(__assign({}, getBackgroundColor(palette)), { width: '10%' }) }, { children: "Famille" })), _jsx(TableCell, __assign({ sx: __assign(__assign({}, getBackgroundColor(palette)), { width: '20%' }) }, { children: "Gamme" })), _jsx(TableCell, __assign({ sx: __assign(__assign({}, getBackgroundColor(palette)), { width: '30%' }) }, { children: "Produit / Service" })), _jsx(TableCell, __assign({ align: "right", sx: getBackgroundColor(palette) }, { children: "Quantit\u00E9" })), _jsx(TableCell, __assign({ align: "right", sx: getBackgroundColor(palette) }, { children: "Tarif" })), _jsx(TableCell, __assign({ align: "right", sx: getBackgroundColor(palette) }, { children: "Co\u00FBt" })), originalUser.Licence.UseTva ? (_jsx(TableCell, __assign({ align: "right", sx: getBackgroundColor(palette) }, { children: "Tva" }))) : (_jsx(_Fragment, {})), _jsx(TableCell, { sx: getBackgroundColor(palette) })] }) }), _jsx(TableBody, { children: types.map(function (type) { return (_jsx(RowType, { type: type }, type.IdType)); }) })] }) })), renderEditionProduit(), renderEditionFamille(), renderEditionType()] }));
};
//# sourceMappingURL=Catalogue.js.map